const handleLogout = () => {
  localStorage.removeItem("jwt");
  localStorage.removeItem("email");
  window.location = "/";
};
export default handleLogout;
